import { features } from "../../../mocks/features";

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full bg-[#F8F9FA] py-20 md:py-28">
      <div className="w-full px-6 md:px-10 lg:px-14">
        <div className="text-center mb-14 md:mb-18">
          <span className="inline-block text-sm font-medium text-[#4CAF50] border border-[#4CAF50]/30 rounded-full px-4 py-1.5 mb-5">
            Powerful Features
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 tracking-tight">
            Everything You Need
          </h2>
          <p className="mt-4 text-base text-gray-500 max-w-xl mx-auto">
            A complete toolkit for document management — from capture to sharing
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((f) => (
            <div
              key={f.id}
              className="bg-white rounded-2xl p-7 md:p-8 border border-transparent hover:border-[#4A90D9]/20 hover:-translate-y-2 hover:shadow-lg transition-all duration-300 group cursor-default"
            >
              <div
                className={`w-14 h-14 ${f.color} rounded-xl flex items-center justify-center mb-5`}
              >
                <span className={`w-7 h-7 flex items-center justify-center ${f.iconColor}`}>
                  <i className={`${f.icon} text-xl`}></i>
                </span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                {f.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {f.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}